const assetContext = require.context('../images', true, /\.(png|jpe?g|webp|gif|svg|mp4|webm)$/);

const resolveAsset = (relativePath) => {
  const normalized = relativePath.replace(/^\.?\//, '');
  try {
    return assetContext(`./${normalized}`);
  } catch (error) {
    console.warn(`[projects] Asset not found: ${relativePath}`);
    return '';
  }
};

export const projects = [
  {
    id: 1,
    year: "2025",
    date: "June 2025",
    readTime: "~8 min. read",
    title: "Final Thesis Project",
    shortTitle: "thesis",
    description:
      "For my final thesis I developed an interactive onboarding website for future interns at Friends of Cartel. The journey bundles Webflow prototypes, AI-generated content, and video modules into one user-friendly experience. This case captures the full process from concept to final presentation between February and May 2025.",
    tag: "Design",
    color: "#5196fd",
    image: resolveAsset('final-thesis-project/project-1-img-25.png'),
    hoverImage: resolveAsset('final-thesis-project/project-1-img-13.png'),
    sector: "Education",
    services: "Experience Design, Onboarding Strategy, Motion Design",
    technologies: "GSAP, Figma, Webflow, AI, After Effects, Premiere Pro, Blender, Photoshop, Illustrator",
    siteUrl: "https://ioxeds-exceptional-site.webflow.io/",
    config: {
      clientReview: {
        enabled: false,
        title: "Look at the website Urself",
        description: "https://ioxeds-exceptional-site.webflow.io/"
      },
      extraImages: {
        enabled: true,
        folderPath: "/images/final-thesis-project",
        images: [
          { src: resolveAsset('final-thesis-project/project-1-img-14.png'), enabled: true },
          { src: resolveAsset('final-thesis-project/project-1-img-15.png'), enabled: true },
          { src: resolveAsset('final-thesis-project/project-1-img-2.png'), enabled: true },
          { src: resolveAsset('final-thesis-project/project-1-img-21.png'), enabled: true },
          { src: resolveAsset('final-thesis-project/project-1-img-22.png'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/final-thesis-project",
        images: [
          resolveAsset('final-thesis-project/project-1-img-10.png'),
          resolveAsset('final-thesis-project/project-1-img-13.png'),
          resolveAsset('final-thesis-project/project-1-img-11.png'),
          resolveAsset('final-thesis-project/project-1-img-6.png'),
          resolveAsset('final-thesis-project/project-1-img-7.png'),
          resolveAsset('final-thesis-project/project-1-img-20.png')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('final-thesis-project/project-1-img-25.png')
      }
    }
  },
  {
    id: 2,
    year: "2025",
    date: "April 2025",
    readTime: "~4 min. read",
    title: "Bilzen-Hoeselt Animations",
    shortTitle: "bilzen-hoeselt",
    description:
      "This animation series for Bilzen-Hoeselt transforms local events into dynamic social content. During my internship at Friends of Cartel I experimented with branded motion, color palettes, and typographic accents to make the campaign stand out. The short clips formed the basis for consistent communication in April 2025.",
    tag: "Motion Graphics",
    color: "#13006c",
    image: resolveAsset('bilzen-hoeselt-animations/project-2-img-1.png'),
    hoverImage: resolveAsset('bilzen-hoeselt-animations/project-2-vid-2.webm'),
    sector: "Municipality & Tourism",
    services: "Social Content, Animation Production",
    technologies: "After Effects, Illustrator, Premiere Pro",
    siteUrl: "",
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "",
        images: [],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO'S",
        videoSrc: resolveAsset('bilzen-hoeselt-animations/project-2-vid-1.webm'),
        videoThumbnail: resolveAsset('bilzen-hoeselt-animations/project-2-img-1.png')
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/bilzen-hoeselt-animations",
        images: [
          resolveAsset('bilzen-hoeselt-animations/project-2-vid-1.webm'),
          resolveAsset('bilzen-hoeselt-animations/project-2-vid-2.webm'),
          
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('bilzen-hoeselt-animations/project-2-img-1.png')
      }
    }
  },
  {
    id: 3,
    year: "2025",
    date: "May 2025",
    readTime: "~4 min. read",
    title: "Multipharma Motion Graphics",
    shortTitle: "multipharma",
    description:
      "For Multipharma I created a set of motion graphics that make their pharmacy services more accessible. I translated complex information into clear animations, including iconography, subtle 3D elements, and soft transition effects. The project was completed in May 2025 within the Friends of Cartel team.",
    tag: "Motion Graphics",
    color: "#13006c",
    image: resolveAsset('multipharma-motion-graphics/project-3-img-2.png'),
    hoverImage: resolveAsset('multipharma-motion-graphics/project-3-vid-3.webm'),
    sector: "Healthcare",
    services: "Motion Design, Information Design",
    technologies: "After Effects, Illustrator, Premiere Pro",
    siteUrl: "",
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/multipharma-motion-graphics",
        images: [
          { src: resolveAsset('multipharma-motion-graphics/project-3-img-1.png'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('multipharma-motion-graphics/project-3-vid-1.webm'),
        videoThumbnail: resolveAsset('multipharma-motion-graphics/project-3-img-1.png')
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/multipharma-motion-graphics",
        images: [
          resolveAsset('multipharma-motion-graphics/project-3-vid-1.webm'),
          resolveAsset('multipharma-motion-graphics/project-3-vid-2.webm'),
          resolveAsset('multipharma-motion-graphics/project-3-vid-3.webm'),
          resolveAsset('multipharma-motion-graphics/project-3-vid-4.webm'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('')
      }
    }
  },
  {
    id: 4,
    year: "2025",
    date: "March 2025",
    readTime: "~3 min. read",
    title: "RCA Cafe Poster",
    shortTitle: "rca-cafe",
    description:
      "During my internship I designed this poster for the RCA Cafe, a networking evening at Cartel Agency. I combined hand-drawn elements with expressive typography to highlight the playful vibe of the event. The print and digital variants delivered standout campaign assets in March 2025.",
    tag: "Design",
    color: "#13006c",
    image: resolveAsset('rca-cafe-poster/project-4-img-1.webp'),
    hoverImage: resolveAsset('rca-cafe-poster/project-4-img-2.webp'),
    sector: "Events & Culture",
    services: "Print Design, Campaign Collateral",
    technologies: "Illustrator, Photoshop, Procreate",
    siteUrl: "",
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: true,
        folderPath: "/images/rca-cafe-poster",
        images: [
          { src: resolveAsset('rca-cafe-poster/project-4-img-1.png'), enabled: true },
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/rca-cafe-poster",
        images: [
          resolveAsset('rca-cafe-poster/project-4-img-1.png'),
          resolveAsset('rca-cafe-poster/project-4-img-1.webp'),
          resolveAsset('rca-cafe-poster/project-4-img-2.webp')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('rca-cafe-poster/project-4-img-1.png')
      }
    }
  },
  {
    id: 5,
    year: "2025",
    date: "May 2025",
    readTime: "~3 min. read",
    title: "Becoland Logo Animation",
    shortTitle: "becoland",
    description:
      "For Becoland I developed a typography-driven logo animation that reinforces the brand personality. I tested different rhythms, glow effects, and transition frames so the motion works both online and at events. The final result aligns with the Friends of Cartel style guidelines from May 2025.",
    tag: "Motion Graphics",
    color: "#13006c",
    image: resolveAsset('becoland-logo-animation/project-5-img-1.png'),
    hoverImage: resolveAsset('becoland-logo-animation/project-5-vid-1.webm'),
    sector: "Food & Leisure",
    services: "Logo Animation, Brand Motion Toolkit",
    technologies: "After Effects, Illustrator, Premiere Pro",
    siteUrl: "",
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/becoland-logo-animation",
        images: [
          { src: resolveAsset('becoland-logo-animation/project-5-featured.jpg'), enabled: true },
          { src: resolveAsset('becoland-logo-animation/project-5-img-1.png'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('becoland-logo-animation/project-5-vid-1.webm'),
        videoThumbnail: resolveAsset('becoland-logo-animation/project-5-featured.jpg')
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/becoland-logo-animation",
        images: [
          resolveAsset('becoland-logo-animation/project-5-vid-1.webm'),
          resolveAsset('becoland-logo-animation/project-5-vid-2.webm'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('becoland-logo-animation/project-5-featured.jpg')
      }
    }
  },
  {
    id: 6,
    year: "2025",
    date: "2025",
    readTime: "~3 min. read",
    title: "Palpatine VFX Study",
    shortTitle: "palpatine",
    description:
      "In this VFX study I bring Emperor Palpatine to life through color grading, rotoscoping, and compositing. I experimented with lightning effects and cinematic lighting to recreate the Star Wars atmosphere. The project helped me refine my After Effects pipeline.",
    tag: "Video",
    color: "#13006c",
    image: resolveAsset('palpatine-vfx-study/project-6-img-1.webp'),
    hoverImage: resolveAsset('palpatine-vfx-study/project-6-vid-1.webm'),
    sector: "Entertainment",
    services: "Compositing, VFX Experimentation",
    technologies: "After Effects, Photoshop, Premiere Pro",
    siteUrl: "",
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/palpatine-vfx-study",
        images: [
          { src: resolveAsset('palpatine-vfx-study/project-6-featured.jpg'), enabled: true },
          { src: resolveAsset('palpatine-vfx-study/project-6-img-1.png'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: true,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('palpatine-vfx-study/project-6-vid-1.webm'),
        videoThumbnail: resolveAsset('palpatine-vfx-study/project-6-featured.jpg')
      },
      horizontalGallery: {
        enabled: false,
        folderPath: "/images/palpatine-vfx-study",
        images: [
          resolveAsset('palpatine-vfx-study/project-6-vid-1.webm'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: false,
        src: resolveAsset('palpatine-vfx-study/project-6-featured.jpg')
      }
    }
  },
  {
    id: 7,
    year: "2025",
    date: "2025",
    readTime: "~3 min. read",
    title: "Spider-Man VFX Experiment",
    shortTitle: "spiderman",
    description:
      "This short Spider-Man animation is a personal exploration of superhero VFX. I combined camera tracking with 3D web simulations to create an energetic mood. The experiment shows how I translate reference material into my own interpretation.",
    tag: "Video",
    color: "#13006c",
    image: resolveAsset('spider-man-vfx-experiment/project-7-img-1.jpg'),
    hoverImage: resolveAsset('spider-man-vfx-experiment/project-7-vid-1.webm'),
    sector: "Entertainment",
    services: "Compositing, Motion Exploration",
    technologies: "After Effects, Blender, Premiere Pro",
    siteUrl: "",
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/spider-man-vfx-experiment",
        images: [
          { src: resolveAsset('spider-man-vfx-experiment/project-7-featured.jpg'), enabled: true },
          { src: resolveAsset('spider-man-vfx-experiment/project-7-img-1.png'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: true,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('spider-man-vfx-experiment/project-7-vid-1.webm'),
        videoThumbnail: resolveAsset('spider-man-vfx-experiment/project-7-featured.jpg')
      },
      horizontalGallery: {
        enabled: false,
        folderPath: "",
        images: [],
        showLabels: false
      },
      bannerImage: {
        enabled: false,
        src: resolveAsset('spider-man-vfx-experiment/project-7-featured.jpg')
      }
    }
  },
  {
    id: 8,
    year: "2025",
    date: "March 2025",
    readTime: "~4 min. read",
    title: "Stop-Motion Film",
    shortTitle: "stop-motion",
    description:
      "For the Motion Design course I produced a stop-motion film where tactile textures take the lead. I photographed every frame manually and synchronized the edit with bespoke sound design. The result is a playful yet technically polished homage to analog animation.",
    tag: "Video",
    color: "#fd521a",
    image: resolveAsset('stop-motion-film/project-8-img-1.jpg'),
    hoverImage: resolveAsset('stop-motion-film/project-8-vid-1.webm'),
    sector: "Education",
    services: "Stop-Motion Production, Sound Design",
    technologies: "Dragonframe, Premiere Pro, Photoshop",
    siteUrl: "",
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/stop-motion-film",
        images: [
          { src: resolveAsset('stop-motion-film/project-8-img-1.png'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: true,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('stop-motion-film/project-8-vid-1.webm'),
        videoThumbnail: resolveAsset('stop-motion-film/project-8-img-1.png')
      },
      horizontalGallery: {
        enabled: false,
        folderPath: "",
        images: [],
        showLabels: false
      },
      bannerImage: {
        enabled: false,
        src: resolveAsset('stop-motion-film/project-8-img-1.png')
      }
    }
  },
  {
    id: 9,
    year: "2024",
    date: "2024",
    readTime: "~3 min. read",
    title: "Dreaming Visual Edit",
    shortTitle: "dreaming",
    description:
      "Dreaming is an audiovisual experiment set to Kanye West's track. I blended footage, glitch-like overlays, and typographic beat syncing to emphasize the dreamlike atmosphere. The edit highlights emotion and timing.",
    tag: "Video",
    color: "#13006c",
    image: resolveAsset('dreaming-visual-edit/project-9-img-1.jpg'),
    hoverImage: resolveAsset('dreaming-visual-edit/project-9-vid-1.webm'),
    sector: "Entertainment",
    services: "Video Editing, Visual Effects",
    technologies: "After Effects, Premiere Pro, Photoshop",
    siteUrl: "",
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/dreaming-visual-edit",
        images: [
          { src: resolveAsset('dreaming-visual-edit/project-9-img-1.png'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: true,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('dreaming-visual-edit/project-9-vid-1.webm'),
        videoThumbnail: resolveAsset('dreaming-visual-edit/project-9-img-1.png')
      },
      horizontalGallery: {
        enabled: false,
        folderPath: "",
        images: [],
        showLabels: false
      },
      bannerImage: {
        enabled: false,
        src: resolveAsset('dreaming-visual-edit/project-9-img-1.png')
      }
    }
  },
  {
    id: 10,
    year: "2025",
    date: "2025",
    readTime: "~6 min. read",
    title: "Charged Logo & Ads",
    shortTitle: "charged",
    description:
      "Charged is a branding track for an energetic lifestyle brand, focusing on logo, ads, and social media. I developed a recognizable visual system with bold color contrasts and modular layouts. The series shows how the concept stays consistent across fourteen deliverables.",
    tag: "Design",
    color: "#13006c",
    image: resolveAsset('charged-logo-and-ads/project-10-img-2.png'),
    hoverImage: resolveAsset('charged-logo-and-ads/project-10-img-2.png'),
    sector: "Lifestyle & Retail",
    services: "Brand Identity, Creative Direction, Advertising Toolkit",
    technologies: "Illustrator, Photoshop, InDesign",
    siteUrl: "",
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: true,
        folderPath: "/images/charged-logo-and-ads",
        images: [
          { src: resolveAsset('charged-logo-and-ads/project-10-img-12.png'), enabled: true },
          { src: resolveAsset('charged-logo-and-ads/project-10-img-13.png'), enabled: true },
          { src: resolveAsset('charged-logo-and-ads/project-10-img-14.png'), enabled: true },
          { src: resolveAsset('charged-logo-and-ads/project-10-img-15.png'), enabled: true },
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/charged-logo-and-ads",
        images: [
          resolveAsset('charged-logo-and-ads/project-10-img-2.png'),
          resolveAsset('charged-logo-and-ads/project-10-img-3.png'),
          resolveAsset('charged-logo-and-ads/project-10-img-4.png'),
          resolveAsset('charged-logo-and-ads/project-10-img-5.png'),
          resolveAsset('charged-logo-and-ads/project-10-img-6.png'),
          resolveAsset('charged-logo-and-ads/project-10-img-7.png'),
          resolveAsset('charged-logo-and-ads/project-10-img-8.png'),
          resolveAsset('charged-logo-and-ads/project-10-img-9.png'),
          resolveAsset('charged-logo-and-ads/project-10-img-10.png'),
          resolveAsset('charged-logo-and-ads/project-10-img-11.png'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('charged-logo-and-ads/project-10-img-2.png')
      }
    }
  },
  {
    id: 11,
    year: "2025",
    date: "2025",
    readTime: "~5 min. read",
    title: "Shopping Sundays: City of Hasselt",
    shortTitle: "shopping-sundays",
    description:
      "For the City of Hasselt I designed a campaign identity around the monthly Shopping Sundays. The package includes posters, animations, and social posts that position the city as a vibrant meeting place. I started from audience research and built a colorful visual language.",
    tag: "Design",
    color: "#13006c",
    image: resolveAsset('shopping-sundays-city-of-hasselt/project-11-img-1.webp'),
    hoverImage: resolveAsset('shopping-sundays-city-of-hasselt/project-11-img-5.gif'),
    sector: "Government & Public Sector",
    services: "Campaign Identity, Motion Assets, Social Content",
    technologies: "Illustrator, After Effects, Photoshop",
    siteUrl: "",
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: true,
        folderPath: "/images/shopping-sundays-city-of-hasselt",
        images: [
          { src: resolveAsset('shopping-sundays-city-of-hasselt/project-11-img-11.png'), enabled: true },
          { src: resolveAsset('shopping-sundays-city-of-hasselt/project-11-img-2.png'), enabled: true },
          { src: resolveAsset('shopping-sundays-city-of-hasselt/project-11-img-3.png'), enabled: true },
          { src: resolveAsset('shopping-sundays-city-of-hasselt/project-11-img-4.png'), enabled: true },
          { src: resolveAsset('shopping-sundays-city-of-hasselt/project-11-img-5.png'), enabled: true },
          { src: resolveAsset('shopping-sundays-city-of-hasselt/project-11-img-9.png'), enabled: true },
          { src: resolveAsset('shopping-sundays-city-of-hasselt/project-11-img-10.png'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/shopping-sundays-city-of-hasselt",
        images: [
          resolveAsset('shopping-sundays-city-of-hasselt/project-11-img-5.gif'),
          resolveAsset('shopping-sundays-city-of-hasselt/project-11-img-7.gif'),
          resolveAsset('shopping-sundays-city-of-hasselt/project-11-img-8.gif'),
          resolveAsset('shopping-sundays-city-of-hasselt/project-11-img-9.gif')
        ],
        showLabels: true
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('shopping-sundays-city-of-hasselt/project-11-img-1.png')
      }
    }
  },
  {
    id: 14,
    year: "2024",
    date: "2024",
    readTime: "~3 min. read",
    title: "Lil Yachty Video Edit",
    shortTitle: "lil-yachty",
    description:
      "With this Lil Yachty edit I refined my workflow for fast, punchy cuts. I experimented with frame-perfect rhythms, handcrafted overlays, and custom transitions to amplify the track. The video marks a step forward compared to my earlier edits.",
    tag: "Video",
    color: "#fd521a",
    image: resolveAsset('lil-yachty-video-edit/project-14-img-1.jpg'),
    hoverImage: resolveAsset('lil-yachty-video-edit/project-14-vid-1.webm'),
    sector: "Entertainment",
    services: "Music Video Edit, Motion Design",
    technologies: "After Effects, Premiere Pro, Photoshop",
    siteUrl: "",
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: true,
        folderPath: "/images/lil-yachty-video-edit",
        images: [
          { src: resolveAsset('lil-yachty-video-edit/project-14-img-1.png'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: true,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('lil-yachty-video-edit/project-14-vid-1.webm'),
        videoThumbnail: resolveAsset('lil-yachty-video-edit/project-14-img-1.png')
      },
      horizontalGallery: {
        enabled: false,
        folderPath: "",
        images: [],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('lil-yachty-video-edit/project-14-img-1.png')
      }
    }
  },
  {
    id: 15,
    year: "2024",
    date: "2024",
    readTime: "~3 min. read",
    title: "Ice Spice Video Edit",
    shortTitle: "ice-spice",
    description:
      "The Ice Spice video is an exercise in variation within a compact format. I combined trendy motion presets with custom graphic elements to keep the pace fresh. Despite the experimental approach I'm happy with the balance between energy and clarity.",
    tag: "Video",
    color: "#fd521a",
    image: resolveAsset('ice-spice-video-edit/project-15-img-1.jpg'),
    hoverImage: resolveAsset('ice-spice-video-edit/project-15-vid-1.webm'),
    sector: "Entertainment",
    services: "Music Video Edit, Motion Templates",
    technologies: "After Effects, Premiere Pro, Photoshop",
    siteUrl: "",
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/ice-spice-video-edit",
        images: [
          { src: resolveAsset('ice-spice-video-edit/project-15-img-1.png'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: resolveAsset('ice-spice-video-edit/project-15-vid-1.webm'),
        videoThumbnail: resolveAsset('ice-spice-video-edit/project-15-img-1.png')
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/ice-spice-video-edit",
        images: [
          resolveAsset('ice-spice-video-edit/project-15-vid-1.webm'),
          resolveAsset('ice-spice-video-edit/project-15-vid-2.webm')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('ice-spice-video-edit/project-15-img-1.png')
      }
    }
  },
  {
    id: 16,
    year: "2025",
    date: "2025",
    readTime: "~4 min. read",
    title: "Harry Potter Secret Chamber",
    shortTitle: "hp-chamber",
    description:
      "This Harry Potter-inspired room shows my concept-to-space process. I designed a playful bedroom, built the set in 3D, and added storytelling objects that reference the books. The visuals contrast reference photos with my final design.",
    tag: "3D",
    color: "#13006c",
    image: resolveAsset('harry-potter-secret-chamber/project-16-img-1.jpg'),
    hoverImage: resolveAsset('harry-potter-secret-chamber/project-16-img-3.jpg'),
    sector: "Entertainment",
    services: "Concept Design, 3D Visualization",
    technologies: "Blender, Photoshop, Illustrator",
    siteUrl: "",
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/harry-potter-secret-chamber",
        images: [
          { src: resolveAsset('harry-potter-secret-chamber/project-16-img-1.jpg'), enabled: true },
          { src: resolveAsset('harry-potter-secret-chamber/project-16-img-2.jpg'), enabled: true },
          { src: resolveAsset('harry-potter-secret-chamber/project-16-img-3.png'), enabled: true },
          { src: resolveAsset('harry-potter-secret-chamber/project-16-img-4.jpg'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/harry-potter-secret-chamber",
        images: [
          resolveAsset('harry-potter-secret-chamber/project-16-img-3.jpg'),
          resolveAsset('harry-potter-secret-chamber/project-16-img-4.png'),
          resolveAsset('harry-potter-secret-chamber/project-16-img-5.jpg')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('harry-potter-secret-chamber/project-16-img-1.jpg')
      }
    }
  },
  {
    id: 17,
    year: "2025",
    date: "2025",
    readTime: "~4 min. read",
    title: "Rome & Japan",
    shortTitle: "rome-japan",
    description:
      "Rome & Japan is a study of architectural atmospheres that merges two cultural worlds. I modeled structures with detailed materials and soft lighting to approach realism. The renders demonstrate my search for balance between minimalism and detail.",
    tag: "3D",
    color: "#13006c",
    image: resolveAsset('rome-and-japan/project-17-img-1.jpg'),
    hoverImage: resolveAsset('rome-and-japan/project-17-img-3.png'),
    sector: "Visualization",
    services: "3D Modeling, Lighting, Rendering",
    technologies: "Blender, Photoshop, Illustrator",
    siteUrl: "",
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/rome-and-japan",
        images: [
          { src: resolveAsset('rome-and-japan/project-17-img-1.jpg'), enabled: true },
          { src: resolveAsset('rome-and-japan/project-17-img-2.png'), enabled: true },
          { src: resolveAsset('rome-and-japan/project-17-img-3.png'), enabled: true },
          { src: resolveAsset('rome-and-japan/project-17-img-4.jpg'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/rome-and-japan",
        images: [
          resolveAsset('rome-and-japan/project-17-img-1.jpg'),
          resolveAsset('rome-and-japan/project-17-img-2.png'),
          resolveAsset('rome-and-japan/project-17-img-3.png'),
          resolveAsset('rome-and-japan/project-17-img-4.jpg'),
          resolveAsset('rome-and-japan/project-17-img-5.png'),
          resolveAsset('rome-and-japan/project-17-img-6.png'),
          resolveAsset('rome-and-japan/project-17-img-7.png')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('rome-and-japan/project-17-img-1.jpg')
      }
    }
  },
  {
    id: 19,
    year: "2024",
    date: "March 2024",
    readTime: "~4 min. read",
    title: "Space Train",
    shortTitle: "space-train",
    description:
      "Space Train translates a poster by artist Karaska into a 3D sci-fi scene. I built an abandoned train carriage with surreal light sources and atmospheric fog. The project marks my first steps toward narrative worldbuilding in March 2024.",
    tag: "3D",
    color: "#13006c",
    image: resolveAsset('space-train/project-19-img-1.jpg'),
    hoverImage: resolveAsset('space-train/project-19-img-3.png'),
    sector: "Entertainment",
    services: "Concept Development, 3D Illustration",
    technologies: "Blender, Photoshop, Illustrator",
    siteUrl: "",
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/space-train",
        images: [
          { src: resolveAsset('space-train/project-19-img-1.jpg'), enabled: true },
          { src: resolveAsset('space-train/project-19-img-2.png'), enabled: true },
          { src: resolveAsset('space-train/project-19-img-3.png'), enabled: true },
          { src: resolveAsset('space-train/project-19-img-4.png'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/space-train",
        images: [
          resolveAsset('space-train/project-19-img-1.jpg'),
          resolveAsset('space-train/project-19-img-2.png'),
          resolveAsset('space-train/project-19-img-3.png'),
          resolveAsset('space-train/project-19-img-4.png')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('space-train/project-19-img-1.jpg')
      }
    }
  },
  {
    id: 20,
    year: "2024",
    date: "June 2024",
    readTime: "~6 min. read",
    title: "PXL Esports Case",
    shortTitle: "pxl-esports",
    description:
      "For PXL Esports I contributed to a full rebrand, including the digital platform. I developed UI components, app flows, and promotional material that resonates with students. The case covers the journey from analysis and visual direction to functional prototypes between January and June 2024.",
    tag: "Design",
    color: "#13006c",
    image: resolveAsset('pxl-esports-case/project-20-img-1.jpg'),
    hoverImage: resolveAsset('pxl-esports-case/project-20-img-3.jpg'),
    sector: "Education",
    services: "Brand Identity, Product Design, Campaign Collateral",
    technologies: "Figma, Illustrator, InDesign, Webflow",
    siteUrl: "",
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/pxl-esports-case",
        images: [
          { src: resolveAsset('pxl-esports-case/project-20-img-1.jpg'), enabled: true },
          { src: resolveAsset('pxl-esports-case/project-20-img-2.jpg'), enabled: true },
          { src: resolveAsset('pxl-esports-case/project-20-img-3.jpg'), enabled: true },
          { src: resolveAsset('pxl-esports-case/project-20-img-4.jpg'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/pxl-esports-case",
        images: [
          resolveAsset('pxl-esports-case/project-20-img-1.jpg'),
          resolveAsset('pxl-esports-case/project-20-img-2.jpg'),
          resolveAsset('pxl-esports-case/project-20-img-3.jpg'),
          resolveAsset('pxl-esports-case/project-20-img-4.jpg'),
          resolveAsset('pxl-esports-case/project-20-img-5.jpg'),
          resolveAsset('pxl-esports-case/project-20-img-6.jpg'),
          resolveAsset('pxl-esports-case/project-20-img-7.jpg'),
          resolveAsset('pxl-esports-case/project-20-img-8.jpg'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('pxl-esports-case/project-20-img-1.jpg')
      }
    }
  },
  {
    id: 21,
    year: "2024",
    date: "March 2024",
    readTime: "~2 min. read",
    title: "Light Beam Poster",
    shortTitle: "light-beam",
    description:
      "The Light Beam poster experiments with typographic minimalism and gentle shadow play. I explored how beams of light can guide graphic compositions and translated that into a serene campaign visual. The concept was presented in March 2024 as a studio workshop deliverable.",
    tag: "Design",
    color: "#13006c",
    image: resolveAsset('light-beam-poster/project-21-img-1.jpg'),
    hoverImage: resolveAsset('light-beam-poster/project-21-img-2.jpg'),
    sector: "Conceptual Design",
    services: "Poster Design, Concept Exploration",
    technologies: "Illustrator, Photoshop",
    siteUrl: "",
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: true,
        folderPath: "/images/light-beam-poster",
        images: [
          { src: resolveAsset('light-beam-poster/project-21-img-1.jpg'), enabled: true },
          { src: resolveAsset('light-beam-poster/project-21-img-2.png'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: false,
        folderPath: "",
        images: [
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('light-beam-poster/project-21-img-1.jpg')
      }
    }
  },
  {
    id: 22,
    year: "2024",
    date: "April 2024",
    readTime: "~3 min. read",
    title: "Personal Logo",
    shortTitle: "personal-logo",
    description:
      "This personal logo project started with target audience research and brand values. I sketched dozens of variations before arriving at this geometric signature. The final emblem works both digitally and in print thanks to its modular construction.",
    tag: "Design",
    color: "#13006c",
    image: resolveAsset('personal-logo/project-22-img-1.jpg'),
    hoverImage: resolveAsset('personal-logo/project-22-img-2.jpg'),
    sector: "Personal Brand",
    services: "Logo Design, Visual Identity",
    technologies: "Illustrator, Photoshop, Figma",
    siteUrl: "",
    config: {
      clientReview: {
        enabled: true,
        title: "WHY I CHOSE THIS LOGO",
        description: "I chose this logo because it is simple and modern. It is easy to remember and it is easy to use. It is also easy to print and it is easy to use on the web."
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/personal-logo",
        images: [
          { src: resolveAsset('personal-logo/project-22-img-1.jpg'), enabled: true },
          { src: resolveAsset('personal-logo/project-22-img-2.jpg'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/personal-logo",
        images: [
          resolveAsset('personal-logo/project-22-img-1.jpg'),
          resolveAsset('personal-logo/project-22-img-2.jpg'),
          resolveAsset('personal-logo/project-22-img-3.jpg'),
          resolveAsset('personal-logo/project-22-img-4.jpg'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('personal-logo/project-22-img-1.jpg')
      }
    }
  },
  {
    id: 23,
    year: "2021",
    date: "March 2021",
    readTime: "~4 min. read",
    title: "The Abandoned Room",
    shortTitle: "abandoned-room",
    description:
      "The Abandoned Room is a detailed Blender scene with storytelling at its core. I modeled furniture, crafted weathered materials, and directed light to create a melancholic mood. The renders show how texturing and compositing reinforce the narrative.",
    tag: "3D",
    color: "#13006c",
    image: resolveAsset('the-abandoned-room/project-23-img-1.jpg'),
    hoverImage: resolveAsset('the-abandoned-room/project-23-img-1.jpg'),
    sector: "Visualization",
    services: "3D Modeling, Texturing, Lighting",
    technologies: "Blender, Photoshop, After Effects",
    siteUrl: "",
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/the-abandoned-room",
        images: [
          { src: resolveAsset('the-abandoned-room/project-23-img-1.jpg'), enabled: true },
          { src: resolveAsset('the-abandoned-room/project-23-img-2.png'), enabled: true },
          { src: resolveAsset('the-abandoned-room/project-23-img-3.png'), enabled: true },
          { src: resolveAsset('the-abandoned-room/project-23-img-4.png'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/the-abandoned-room",
        images: [
          resolveAsset('the-abandoned-room/project-23-img-1.jpg'),
          resolveAsset('the-abandoned-room/project-23-img-2.png'),
          resolveAsset('the-abandoned-room/project-23-img-3.png'),
          resolveAsset('the-abandoned-room/project-23-img-4.png')
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('the-abandoned-room/project-23-img-1.jpg')
      }
    }
  },
  {
    id: 24,
    year: "2024",
    date: "March 2024",
    readTime: "~5 min. read",
    title: "Film Posters",
    shortTitle: "film-posters",
    description:
      "For this series of film posters I reimagined classics as illustrative compositions. I mixed hand-drawn lines with digital color blocks and typography inspired by the original credits. Each poster explores a different palette while staying true to the cinematic identity.",
    tag: "Design",
    color: "#13006c",
    image: resolveAsset('film-posters/project-24-img-2.png'),
    hoverImage: resolveAsset('film-posters/project-24-img-3.png'),
    sector: "Entertainment",
    services: "Illustration, Poster Design, Art Direction",
    technologies: "Illustrator, Photoshop, Procreate",
    siteUrl: "",
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/film-posters",
        images: [
          { src: resolveAsset('film-posters/project-24-img-1.png'), enabled: true },
          { src: resolveAsset('film-posters/project-24-img-2.png'), enabled: true },
          { src: resolveAsset('film-posters/project-24-img-3.jpg'), enabled: true },
          { src: resolveAsset('film-posters/project-24-img-4.jpg'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/film-posters",
        images: [
          resolveAsset('film-posters/project-24-img-2.png'),
          resolveAsset('film-posters/project-24-img-3.png'),
          resolveAsset('film-posters/project-24-img-4.jpg'),
          resolveAsset('film-posters/project-24-img-5.jpg'),
          resolveAsset('film-posters/project-24-img-6.jpg'),
          resolveAsset('film-posters/project-24-img-7.jpg'),
          resolveAsset('film-posters/project-24-img-8.jpg'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('film-posters/project-24-img-1.png')
      }
    }
  },
  {
    id: 25,
    year: "2025",
    date: "October 2025",
    readTime: "~5 min. read",
    title: "Raft ",
    shortTitle: "Raft",
    description:
      "A raft i made during my class 3D artist at SyntraPXL school and i used 3DS Max and Blender for rendering ",
    tag: "3D",
    color: "#13006c",
    image: resolveAsset('raft/sander-redndersubstance.webp'),
    hoverImage: resolveAsset('raft/sander-3dsmax.webp'),
    sector: "Game art ",
    services: "3D Modeling, Texturing, Lighting",
    technologies: "3DS Max, Blender, Substance Painter, Photoshop",
    siteUrl: "https://www.artstation.com/artwork/x3VPVr",
    config: {
      clientReview: {
        enabled: false,
        title: "",
        description: ""
      },
      extraImages: {
        enabled: false,
        folderPath: "/images/film-posters",
        images: [
          { src: resolveAsset('film-posters/project-24-img-1.png'), enabled: true },
          { src: resolveAsset('film-posters/project-24-img-2.png'), enabled: true },
          { src: resolveAsset('film-posters/project-24-img-3.jpg'), enabled: true },
          { src: resolveAsset('film-posters/project-24-img-4.jpg'), enabled: true }
        ],
        maxImages: null
      },
      watchVideo: {
        enabled: false,
        title: "WATCH\nTHE VIDEO",
        videoSrc: "",
        videoThumbnail: ""
      },
      horizontalGallery: {
        enabled: true,
        folderPath: "/images/film-posters",
        images: [
          resolveAsset('raft/sander-3dsmax.webp'),
          resolveAsset('raft/sander-redndersubstance.webp'),
          resolveAsset('raft/sander-rendered.webp'),
        ],
        showLabels: false
      },
      bannerImage: {
        enabled: true,
        src: resolveAsset('raft/sander-redndersubstance.webp')
      }
    }
  },
];

const splitTagValue = (rawValue) => {
  if (!rawValue) return [];

  const values = Array.isArray(rawValue) ? rawValue : [rawValue];

  return values
    .flatMap((value) =>
      typeof value === 'string'
        ? value
            .split(',')
            .map((tag) => tag.trim())
        : []
    )
    .filter(Boolean);
};

export const getProjectTags = (project) => {
  if (!project) return [];
  return splitTagValue(project.tag);
};

// Helper om tags te extraheren
export const getAllTags = () => {
  const tagSet = new Set();
  projects.forEach((project) => {
    getProjectTags(project).forEach((tag) => tagSet.add(tag));
  });
  return Array.from(tagSet);
};

// Helper om alle unieke jaren te extraheren
export const getAllYears = () => {
  const years = [...new Set(projects.map(p => p.year))];
  return years.sort((a, b) => b - a); // Sorteer van nieuw naar oud
};

// Helper om een specifiek project op te halen op basis van ID
export const getProjectById = (projectId) => {
  return projects.find(p => p.id === projectId) || projects[0];
};

// Helper om het volgende project te vinden op basis van datum
export const getNextProject = (currentProjectId) => {
  // Sorteer projecten op datum (nieuwste eerst)
  const sortedProjects = [...projects].sort((a, b) => 
    new Date(b.date) - new Date(a.date)
  );
  
  // Vind het huidige project
  const currentIndex = sortedProjects.findIndex(p => p.id === currentProjectId);
  
  // Als het het laatste project is, ga terug naar het eerste
  // Anders, neem het volgende project
  const nextIndex = currentIndex === sortedProjects.length - 1 ? 0 : currentIndex + 1;
  
  return sortedProjects[nextIndex];
};

